import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetTaxInformationRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetTaxInformationResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setTaxInformation = (request: SetTaxInformationRequest, options?: CashRequestOptions) =>
  post<SetTaxInformationRequest, SetTaxInformationResponse>('/2.0/cash/set-tax-information', request, {
    ...options,
    rejectOnError: true,
  })
